import { render } from "./DanhSachVeKhongSoDo.vue?vue&type=template&id=d82bfe14&scoped=true"
import script from "./DanhSachVeKhongSoDo.vue?vue&type=script&lang=js"
export * from "./DanhSachVeKhongSoDo.vue?vue&type=script&lang=js"

import "./DanhSachVeKhongSoDo.vue?vue&type=style&index=0&id=d82bfe14&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82bfe14"]])

export default __exports__